import { IGenericJSON } from '../helpers/interface';
import { User } from './user';

export class Comment {
  id: number;
  user_id: number;
  post_id: number;
  parent_id: number;
  content: string;
  date: Date;
  user: User | null;
  replies: Comment[];

  constructor(data: IGenericJSON) {
    this.id = data['id'];
    this.user_id = data['user_id'];
    this.post_id = data['post_id'];
    this.parent_id = data['parent_id'];
    this.content = data['content'];
    this.date = new Date(data['createdAt']);
    this.replies = data['replies']
      ? data['replies'].map((r: IGenericJSON) => Comment.digest(r))
      : [];
    this.user = data['User'] ? User.digest(data['User']) : null;
  }

  public static digest(data: IGenericJSON): Comment {
    return new Comment(data);
  }

  public static digestResponse(data: IGenericJSON[]): Comment[] {
    const ret: Comment[] = [];
    data.forEach((u: IGenericJSON): void => {
      ret.push(this.digest(u));
    });
    return ret;
  }
}
